import { useEffect } from 'react';

/**
 * Listens for Escape key while active and calls onClose.
 * Uses document capture phase so it runs before focused inputs and MUI portaled content.
 * Used by standalone editable cells (description, date, dropdown, multiselect)
 * so ESC cancels and clears the table's editable state.
 */
export function useEscapeToClose(isActive: boolean, onClose?: () => void): void {
  useEffect(() => {
    if (!isActive || !onClose) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown, true);
    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [isActive, onClose]);
}
